module.exports = __webpack_public_path__ + "img/hum_small.18f2fcdb.svg";